export default function Footer() {
  return (
    <footer className="bg-purple-800 text-white p-4 mt-8">
      <div className="container mx-auto text-center">
        &copy; 2026 Madhouse Miners - All rights reserved.
      </div>
    </footer>
  );
}